import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NxiCommonModule } from '@pershing/nxi-common';
import { ContentManagementModule } from '@pershing/nxi-contentmanagement';
import { ModPreloginModule } from '@pershing/nxi-ng-mod';
import { NxiModernNavigationModule } from '@pershing/nxi-ng-modern-navigation';
import { PershingF2Module } from '@pershing/pershing-f2';
import { AccountPickerComponent } from './components/account-picker.component';
import { PageContentComponent } from './components/ada-page-content.component';
import { BiometricAuthComponent } from './components/biometric-auth.component';
import { DAProgressBarComponent } from './components/da-progress-bar.component';
import { NxiF2Common } from './components/f2.common';
import { NxiF2Title } from './components/f2.title';
import { FooterComponent } from './components/footer.component';
import { GoogleAnalyticsComponent } from './components/googleAnalytics.component';
import { NxiHeaderComponent } from './components/header.component';
import { LastLoginComponent } from './components/lastLogin.component';
import { ModernThemeFooterComponent } from './components/modern-theme-footer.component';
import { NxiModernThemeHeaderComponent } from './components/modern-theme-header.component';
import { NxiF2Component } from './components/nxi-f2.component';
import { ProfileMenuComponent } from './components/profile-menu/profile-menu.component';
import { SessionTimeoutComponent } from './components/sessiontimeout-warning.component';
import { NxiCookieService } from './services/NXI-Cookie.service';
import { NxiRestService } from './services/NXI-Rest.service';
import { PortalComponentService } from './services/portal-component.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const NXI_PORTAL_COMPONENTS = [
  NxiHeaderComponent,
  FooterComponent,
  LastLoginComponent,
  NxiF2Component,
  NxiF2Title,
  NxiF2Common,
  PageContentComponent,
  SessionTimeoutComponent,
  AccountPickerComponent,
  GoogleAnalyticsComponent,
  BiometricAuthComponent,
  DAProgressBarComponent,
  ProfileMenuComponent,  
  NxiModernThemeHeaderComponent,
  ModernThemeFooterComponent
];

@NgModule({
  imports: [
    NxiCommonModule,
    ContentManagementModule,
    ModPreloginModule,
    PershingF2Module,
    MatDialogModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatButtonModule,
    MatProgressBarModule,
    MatMenuModule,
    MatDividerModule,
    MatExpansionModule,
    MatCardModule,
    MatTooltipModule,
    MatSelectModule,
    PortalModule,
    OverlayModule,
    MatProgressBarModule,
    NxiModernNavigationModule
  ],
  declarations: [...NXI_PORTAL_COMPONENTS],
  exports: [...NXI_PORTAL_COMPONENTS],
  entryComponents: [SessionTimeoutComponent],
  providers: [PortalComponentService, NxiRestService, NxiCookieService]
})
export class PortalComponentsModule { }
